export default "__VITE_ASSET__COPNBq5n__"